import React from "react";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { Label } from "@components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";

type Props = {
  openNewSettingsDialog: boolean;
  setOpenNewSettingsDialog: React.Dispatch<React.SetStateAction<boolean>>;
  newSettingsTitle: string;
  setNewSettingsTitle: React.Dispatch<React.SetStateAction<string>>;
  newSettingsDescription: string;
  setNewSettingsDescription: React.Dispatch<React.SetStateAction<string>>;
  handleCreateNewSettings: () => void;
  isEditingSettings?: boolean;
  onCancel?: () => void;
};

const SettingsInfo: React.FC<Props> = ({
  openNewSettingsDialog,
  setOpenNewSettingsDialog,
  newSettingsTitle,
  setNewSettingsTitle,
  newSettingsDescription,
  setNewSettingsDescription,
  handleCreateNewSettings,
  isEditingSettings = false,
  onCancel,
}) => {
  return (
    <Dialog
      open={openNewSettingsDialog}
      onOpenChange={setOpenNewSettingsDialog}
    >
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            {isEditingSettings ? "Edit Settings Info" : "Create New Settings"}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4 border rounded-lg p-2">
          <div className="grid gap-2">
            <Label htmlFor="settings-title">Settings Title *</Label>
            <Input
              id="settings-title"
              placeholder="Enter settings title"
              className="border border-secondary focus:ring-secondary focus:ring-2 capitalize"
              value={newSettingsTitle}
              onChange={(e) => setNewSettingsTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleCreateNewSettings();
                }
              }}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="settings-description">Description</Label>
            <textarea
              id="settings-description"
              placeholder="Enter settings description"
              className="border border-secondary focus:ring-secondary focus:ring-2 p-2 text-xs rounded-lg"
              value={newSettingsDescription}
              rows={5}
              onChange={(e) => setNewSettingsDescription(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              if (onCancel) {
                onCancel();
              } else {
                setOpenNewSettingsDialog(false);
                setNewSettingsTitle("");
                setNewSettingsDescription("");
              }
            }}
          >
            Cancel
          </Button>
          <Button type="button" onClick={handleCreateNewSettings}>
            {isEditingSettings ? "Update Settings" : "Create Settings"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsInfo;
